import CustomButton from '../../../common/components/CustomButton';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

/**
 * 完了画面
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeModificationFormView4({
  amount,
  paymentUrl,
  onBackToHome,
} : {
  amount: number,
  paymentUrl: string,
  onBackToHome: () => void,
}) {
  return (
    <>
      <form>
        <div className="form__body">
          <dl>
            <dd>
              修正依頼の受付が完了しました。
              <br />
              <br />
              修正作業が完了しましたらメールにてご連絡いたします。
              <br />
              それまでの間、この曲のその他の手続きを進めないようにお願いいたします。
              <br />
              「修正依頼受付完了」というメールが届いているか必ず確認してください。
              <br />
              (届かない場合は
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a href="https://help.frekul.com/140/" target="_blank">こちら</a>
              からお問合せください。)
              <br />
              {amount > 0 && (
                <>
                  <br />
                  <br />
                  {`修正手数料は【${CurrencyUtility.format(amount)}円】です。`}
                  <br />
                  入金確認後、修正作業に順次着手します。
                  <br />
                  <br />
                  ●クレジットカードでお支払いの場合
                  <br />
                  このまま
                  {/* eslint-disable-next-line react/jsx-no-target-blank */}
                  <a href={paymentUrl} target="_blank">決済サービスStripeのページ</a>
                  に進み、お支払いください。
                  <br />
                  <br />
                  ●銀行振込でお支払いの場合
                  <br />
                  以下の口座にお振込みをお願いします。
                  <br />
                  <br />
                  PayPay銀行（銀行コード 0033）
                  <br />
                  すずめ支店（店番号 002）
                  <br />
                  普通 7713904
                  <br />
                  口座名義：株式会社ワールドスケープ
                  <br />
                  カタカナ表記の場合：カ）ワールドスケープ
                  <br />
                  <br />
                  ※※※重要！振り込み時の注意事項※※※
                  <br />
                  ・お振込み名義と「申込者名」が違うと、入金の確認ができないことがあります。お振込口座の名義と申込者名が異なる場合、備考欄に申込者名を書いてください。
                  <br />
                  ・振込手数料はお客様のご負担となります。
                  <br />
                  ・複数の支払いがある場合は合算して振り込んでOKです。
                  <br />
                </>
              )}
            </dd>
          </dl>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel" onClick={() => onBackToHome()}>ホームに戻る</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
}
